import { format, parseISO } from 'date-fns'
import { FarcanaStatsResponse } from '@/entities/integration/types'
import { formatNumber } from './formatNumber'
import { lang } from '../constants/lang'

export type FormattedFarcanaStats = {
  name: string
  value: string | number | null
}

export const formatFarcanaStats = (data: FarcanaStatsResponse, userLang: 'en' | 'ru'): FormattedFarcanaStats[] => {
  const units = lang[userLang].pages.units
  const texts = lang[userLang].pages.farcanaProfile.stats

  const totalHoursPlayedFormatted = data.totalHoursPlayed
    ? `${data.totalHoursPlayed.toFixed(0)}${units.hours}`.toLowerCase()
    : '?'

  const totalAssetsValueFormatted = data.totalAssetsValue
    ? `${units.dollar}${formatNumber(
        Math.floor(data.totalAssetsValue).toLocaleString('en-US', {
          useGrouping: false,
        })
      )}`
    : '?'

  const dailyStreakLengthFormatted = data.dailyStreakLength
    ? `${data.dailyStreakLength}${units.days.toLowerCase()}`
    : '?'

  const registrationDateFormatted = data.registrationDate ? format(parseISO(data.registrationDate), 'dd.MM.yyyy') : '?'

  const totalMatchesPlayedFormatted = data.totalMatchesPlayed
    ? data.totalMatchesPlayed.toLocaleString('en-US', {
        useGrouping: false,
      })
    : '?'

  const averageDailyPlaytimeSplitted = data.averageDailyPlaytime ? data.averageDailyPlaytime.toString().split('.') : '?'
  const averageDailyPlaytimeHours = data.averageDailyPlaytime ? averageDailyPlaytimeSplitted![0] : null
  const averageDailyPlaytimeMinutes = data.averageDailyPlaytime ? averageDailyPlaytimeSplitted![1] : null
  const averageDailyPlaytimeFormatted = data.averageDailyPlaytime
    ? `${averageDailyPlaytimeHours}${units.hours} ${averageDailyPlaytimeMinutes}${units.minutes}`.toLowerCase()
    : '?'

  return [
    {
      name: texts.totalHoursPlayed,
      value: totalHoursPlayedFormatted,
    },
    {
      name: texts.totalAssetsValue,
      value: totalAssetsValueFormatted,
    },
    {
      name: texts.dailyStreakLength,
      value: dailyStreakLengthFormatted,
    },
    {
      name: texts.registrationDate,
      value: registrationDateFormatted,
    },
    {
      name: texts.totalMatchesPlayed,
      value: totalMatchesPlayedFormatted,
    },
    {
      name: texts.averageDailyPlaytime,
      value: averageDailyPlaytimeFormatted,
    },
    {
      name: texts.KDA,
      value: data.KDA ? data.KDA : '?',
    },
    {
      name: texts.winrate,

      value: data.winrate ? data.winrate : '?',
    },
  ]
}
